import React from 'react';
import { Link } from 'react-router-dom';
import { HelpHero } from '../components/HelpHero';
import { Breadcrumb } from '../components/Breadcrumb';
import { RefreshCw, Bell, Calendar, CheckCircle } from 'lucide-react';
import { articles, categories } from '../data/articles';
export function RecurringOrdersPage() {
  const categoryArticles = articles.filter(a => a.categorySlug === 'compras-recurrentes');
  return <div className="min-h-screen bg-[#f8fafc]" data-id="element-416">
      <HelpHero title="Compras Recurrentes" subtitle="Automatiza tu salud y nunca olvides tus medicamentos." showSearch={true} data-id="element-417" />

      <main className="max-w-7xl mx-auto px-4 md:px-8 py-10" data-id="element-418">
        <div className="flex flex-col lg:flex-row gap-10" data-id="element-419">
          {/* Left Sidebar */}
          <aside className="w-full lg:w-1/4 flex-shrink-0" data-id="element-420">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 sticky top-6" data-id="element-421">
              <h3 className="font-bold text-[#022a3b] mb-4 text-lg" data-id="element-422">
                Centro de Ayuda
              </h3>
              <nav className="space-y-1" data-id="element-423">
                {categories.map(category => <Link key={category.slug} to={`/${category.slug}`} className={`block py-2.5 px-3 rounded-md transition-colors ${category.slug === 'compras-recurrentes' ? 'bg-[#f0f9ff] text-[#0af] font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-[#022a3b]'}`} data-id="element-424">
                    {category.name}
                  </Link>)}
              </nav>
            </div>
          </aside>

          {/* Right Content */}
          <div className="w-full lg:w-3/4" data-id="element-425">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-10 mb-8" data-id="element-426">
              <Breadcrumb items={[{
              label: 'Compras Recurrentes'
            }]} data-id="element-427" />

              <div className="flex items-center gap-3 mb-8" data-id="element-428">
                <div className="p-2 bg-[#e0f2fe] rounded-lg text-[#0af]" data-id="element-429">
                  <RefreshCw className="h-6 w-6" data-id="element-430" />
                </div>
                <h1 className="text-3xl font-bold text-[#022a3b]" data-id="element-431">
                  Compras Recurrentes
                </h1>
              </div>

              <p className="text-gray-600 mb-8" data-id="element-432">
                Consulta aquí toda la información sobre tus compras recurrentes
                y suscripciones.
              </p>

              <div className="space-y-0 divide-y divide-gray-100" data-id="element-433">
                {categoryArticles.map(article => <Link key={article.slug} to={`/${article.slug}`} className="block py-4 text-[#022a3b] hover:text-[#0af] transition-colors" data-id="element-434">
                    {article.title}
                  </Link>)}
              </div>
            </div>

            {/* Benefits Section */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-435">
              <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm text-center" data-id="element-436">
                <div className="w-12 h-12 bg-[#e0f2fe] rounded-full flex items-center justify-center mx-auto mb-4 text-[#0af]" data-id="element-437">
                  <Bell className="h-6 w-6" data-id="element-438" />
                </div>
                <h3 className="font-bold text-[#022a3b] mb-2" data-id="element-439">Recordatorios</h3>
                <p className="text-gray-600 text-sm" data-id="element-440">
                  Te avisamos antes de procesar tu siguiente pedido para que
                  confirmes.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm text-center" data-id="element-441">
                <div className="w-12 h-12 bg-[#fff7ed] rounded-full flex items-center justify-center mx-auto mb-4 text-[#ff5a00]" data-id="element-442">
                  <Calendar className="h-6 w-6" data-id="element-443" />
                </div>
                <h3 className="font-bold text-[#022a3b] mb-2" data-id="element-444">Flexibilidad</h3>
                <p className="text-gray-600 text-sm" data-id="element-445">
                  Elige la frecuencia: cada 15, 30, 60 o 90 días según tu
                  tratamiento.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm text-center" data-id="element-446">
                <div className="w-12 h-12 bg-[#f0fdf4] rounded-full flex items-center justify-center mx-auto mb-4 text-green-600" data-id="element-447">
                  <CheckCircle className="h-6 w-6" data-id="element-448" />
                </div>
                <h3 className="font-bold text-[#022a3b] mb-2" data-id="element-449">
                  Garantía de Abasto
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-450">
                  Reservamos tu inventario para asegurar que siempre tengas tu
                  medicina.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}